import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { EffectiveUserPreferences } from 'src/app/store/user-preferences/user-preferences';
import { UserPreferenceDetailForm, UserPreferenceDetailFormValue } from '../models/user-preference-detail-form';
import { UserPreferenceDetailSaveModel } from '../models/user-preference-detail-save.model';

@Injectable()
export class UserPreferenceDetailFormService extends FormsBase implements OnDestroy {
   private destroyed$ = new Subject<void>();

   constructor(fb: UntypedFormBuilder, private store: Store) {
      super();

      const form: UserPreferenceDetailForm = {
         useAlternatingRowColors: fb.control(null),
      };

      this.form = fb.group(form);
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   updateUserPreferences(userPreferences: EffectiveUserPreferences) {
      const formValue: Partial<UserPreferenceDetailFormValue> = {
         useAlternatingRowColors: userPreferences.UseAlternatingRowColors,
      };

      this.form.patchValue(formValue);
      this.markAsUntouchedAndPristine();
   }

   getValue(userId: number): UserPreferenceDetailSaveModel {
      const value = this.form.value as UserPreferenceDetailFormValue;
      return {
         userId: userId,
         useAlternatingRowColors: value.useAlternatingRowColors,
      };
   }
}
